import React from 'react'
import AsyncPage from 'pages/AsyncPage'

import GroupTools from './GroupTools'

import universal from 'react-universal-component'
const component = universal(props => import('./GroupsPage'))

class AsyncGroupsPage extends AsyncPage {
  nonav = true
  constructor() {
    super({
      pageComponent: component
    })
  }
  getExtraSecondaryNavigation({ place }) {
    return <GroupTools {...place.payload} />
  }
}

export default new AsyncGroupsPage()
